// Единна валута на приложението — евро. Сумите в справките се показват със
// суфикс „€" след непрекъсваем интервал (U+00A0): „165.50 €" —
// ненатрапчиво, числото остава водещо и не се пренася отделно от знака.
// Excel експортите остават чисти числа (не минават оттук).
export const fmtEuro = (
  v: number | string | null | undefined,
  decimals = 2,
): string => {
  const n = typeof v === "number" ? v : Number(v ?? 0);
  return `${(Number.isFinite(n) ? n : 0).toFixed(decimals)}\u00A0€`;
};
